@use '@/scss/underscore' as _;

.totpCodeInput {
  margin-top: _.unit(4);
}
